module.exports = __webpack_public_path__ + "resources/img/logo_partner_commerce_6_m2.089f7ee951f0ccecd02e224727daa81a.png";